export const NAIL_SHOP_INFO = {
  ggMapUrl: "https://maps.app.goo.gl/mvecCWdy6VcTUaQQ8",
  address: "114 Sheen Rd, Richmond TW9 1UR",
  email: "refinedbeautynails@hotmail.com",
  ggMapIframeUrl:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3796.631913789971!2d-0.29506699999999997!3d51.462298!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86c829d3d60280b1%3A0xe11a43161dae20d4!2sRefined%20beauty%20nails!5e1!3m2!1sen!2s!4v1751208772303!5m2!1sen!2s",
  tel: "+447349686686",
  phone: "+44 7349 686 686",
  facebookId: "617016978162972",
  instagramName: "refined_beauty_nails114",
  name: "REFINED BEAUTY NAILS",
  bookingUrl: "https://refinedbeautynails.setmore.com",
  openingTime: {
    openTime: { weekdays: "Mon - Thu", time: "10AM - 7PM" },
    closeTime: { weekdays: "Fri - Sat", time: "9AM - 7PM" },
  },
};

NAIL_SHOP_INFO.instagram = `https://www.instagram.com/${NAIL_SHOP_INFO.instagramName}`;
NAIL_SHOP_INFO.instagramChatUrl = `https://ig.me/m/${NAIL_SHOP_INFO.instagramName}`;
NAIL_SHOP_INFO.facebook = `https://www.facebook.com/profile.php?id=${NAIL_SHOP_INFO.facebookId}`;
NAIL_SHOP_INFO.facebookMessengerUrl = `http://m.me/${NAIL_SHOP_INFO.facebookId}`;

export const SOLCO_INFO = {
  facebook: "https://www.facebook.com/solcoagency.marketing",
  website: "https://solcomarketing.com",

  huaCatLuongWebsite: "https://huacatluong.com",
};

export const LANGUAGE_ID = {
  vi: "vi",
  en: "en",
};

export const CUSTOMER_FEEDBACK = [
  {
    name: "Emily Carter",
    feedback:
      "Ã¢â‚¬Å“Such a welcoming place with professional service and an incredible selection of colors and designs. From the moment I stepped in, I felt like I was in great hands. The atmosphere is calm and soothing, and the technicians pay close attention to every detail. I walked out feeling pampered and confident with beautiful nails that lasted for weeks.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/g7mJPq8.png",
  },
  {
    name: "Chloe Bennett",
    feedback:
      "Ã¢â‚¬Å“Had a lovely experience here today. The team was friendly and made me feel right at home. I appreciated how they listened to what I wanted and gave suggestions that really elevated the look. My nails were done to perfection, and the salon itself is clean, bright, and inviting. This will definitely be my go-to spot for all things nails from now on.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/VxekuRS.png",
  },
  {
    name: "Sophia Turner",
    feedback:
      "Ã¢â‚¬Å“Absolutely thrilled with the results of my manicure and pedicure. The salon is beautifully maintained and has a relaxing vibe that instantly puts you at ease. Every step of the process was smooth and enjoyable. The technicians are clearly skilled and take pride in their work. I received so many compliments after my visit and canÃ¢â‚¬â„¢t wait to return.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/0JaNnhK.png",
  },
  {
    name: "Olivia Morgan",
    feedback:
      "Ã¢â‚¬Å“This place has everything youÃ¢â‚¬â„¢d want from a nail salon Ã¢â‚¬â€ amazing service, skilled technicians, and a peaceful environment that makes it easy to unwind. I've visited multiple times, and the quality is consistently top-notch. They always take their time to make sure everything is just right. I always leave with a smile and flawless nails.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/aCEUi1W.png",
  },
  {
    name: "Zara Mitchell",
    feedback:
      "Ã¢â‚¬Å“It was such a wonderful experience from start to finish. Booking was easy, the team was kind and professional, and the results exceeded my expectations. I love how much care they put into hygiene and customer comfort. Plus, the nail art options are gorgeous. This place makes self-care feel truly special.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/F7M14q2.png",
  },
  {
    name: "Lily Anderson",
    feedback:
      "Ã¢â‚¬Å“From the moment I walked through the door, I was greeted with a warm smile and a relaxing atmosphere. The attention to detail and the quality of the work were impressive. I really appreciated how the staff took the time to ensure I got exactly what I wanted. My nails have never looked better, and I left feeling so refreshed.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/KxhUFKM.jpg",
  },
  {
    name: "Grace Thompson",
    feedback:
      "Ã¢â‚¬Å“Hands down one of the best salon experiences IÃ¢â‚¬â„¢ve had. The environment is serene, the tools are spotless, and the staff are incredibly thoughtful. I felt pampered and cared for the entire time. Not only did I love the final look, but I also appreciated how much time they took to get everything perfect. Highly, highly recommend!Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/kI3rsKc.jpg",
  },
  {
    name: "Mia Robinson",
    feedback:
      "Ã¢â‚¬Å“If youÃ¢â‚¬â„¢re looking for a salon that combines style, skill, and a relaxing experience, look no further. I treated myself to a full set and a pedicure, and both turned out beautifully. The entire team is welcoming and professional, and I felt genuinely cared for. My experience here was nothing short of excellent, and IÃ¢â‚¬â„¢ll definitely be returning soon.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/92gXkP8.jpg",
  },
];

export const MENU_HEADER = [
  { name: "Home", navigationKey: "home" },
  { name: "Gallery", navigationKey: "gallery" },
  { name: "Drinks", navigationKey: "drinks" },
  { name: "Services", navigationKey: "services" },
  { name: "Booking", navigationKey: NAIL_SHOP_INFO.bookingUrl },
  { name: "Contact", navigationKey: "contact-us" },
  { name: "Policy", navigationKey: "policy" },
];

export const DRINKS_MENU = [
  {
    category: "DRINKS",
    drinkList: [
      {
        name: "Diet Coke",
        ingredients: "",
      },
      {
        name: "Water",
        ingredients: "",
      },
    ],
  },
  {
    category: "TEA & COFFEE",
    drinkList: [
      {
        name: "Vietnamese coffee",
        ingredients: "",
      },
      {
        name: "Tea",
        ingredients: "",
      },
    ],
  },
];
